import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary';
import { ExchangeRatePageContent } from './ExchangeRatePageContent';

// Exchange rate configuration page
export const ExchangeRatePage = withDefaultErrorBoundary(ExchangeRatePageContent)
